if (!customElements.get("skincare-routine-block")) {
class SkincareRoutineBlock extends HTMLElement {
  constructor() {
    super();

    this.stepsContainer = this.querySelector(".skincare-routine__steps");
    this.stepsWidth =
      this.querySelector(".inao-product-info").getBoundingClientRect().width +
      12;
    this.currentSelectedStepIndex = 1;
    this.touchStart = 0;
    this.stepCount = this.querySelectorAll(".skincare-routine__step").length;
    this.scrollWrapper = this.querySelector(
      ".skincare-routine__block-scroll-wrapper"
    );

    this.stepsContainer.addEventListener("touchend", (e) => {
      setTimeout(() => {
        const currentStepsContainerScrollLeft = this.stepsContainer.scrollLeft;

        this.currentSelectedStepIndex =
          Math.round(currentStepsContainerScrollLeft / this.stepsWidth) + 1;

        if (this.currentSelectedStepIndex < 1) {
          this.currentSelectedStepIndex = 1;
        }
        if (this.currentSelectedStepIndex > this.stepCount) {
          this.currentSelectedStepIndex = this.stepCount;
        }

        this.querySelector(
          ".skincare-routine__block-featured-media[data-active='true']"
        ).setAttribute("data-active", false);
        this.querySelector(
          `.skincare-routine__block-featured-media[data-step-index='${this.currentSelectedStepIndex}']`
        ).setAttribute("data-active", true);
        console.log("SCROLOLOL to " + this.currentSelectedStepIndex);
      }, 1000);
    });

    this.scrollWrapper.addEventListener("touchstart", (e) => {
      this.touchStartVideo = e.touches[0].clientX;
    });

    this.scrollWrapper.addEventListener("touchend", (e) => {
      const touchDifference =
        e.changedTouches[0].clientX - this.touchStartVideo;

      if (Math.abs(touchDifference) < 50) {
        return;
      }

      const changeStepIndexFactor = touchDifference > 0 ? -1 : 1;
      this.currentSelectedStepIndex =
        this.currentSelectedStepIndex + changeStepIndexFactor;

      if (this.currentSelectedStepIndex < 1) {
        this.currentSelectedStepIndex = 1;
      }
      if (this.currentSelectedStepIndex > this.stepCount) {
        this.currentSelectedStepIndex = this.stepCount;
      }

      this.querySelector(
        ".skincare-routine__block-featured-media[data-active='true']"
      ).setAttribute("data-active", false);
      this.querySelector(
        `.skincare-routine__block-featured-media[data-step-index='${this.currentSelectedStepIndex}']`
      ).setAttribute("data-active", true);

      this.stepsContainer.scrollLeft =
        (this.currentSelectedStepIndex - 1) * this.stepsWidth;
    });
  }
}

customElements.define("skincare-routine-block", SkincareRoutineBlock);
}

if (!customElements.get("skincare-routine-tabs")) {
class SkincareRoutineTabs extends HTMLElement {
  constructor() {
    super();

    // Delegate so switching works even when this instance is constructed
    // before its buttons are parsed (e.g. a second instance created after the
    // element is already defined, which leaves the constructor unable to see
    // its own <button> children).
    this.addEventListener("click", (event) => {
      const button = event.target.closest("button");
      if (!button || !this.contains(button)) return;

      const scope = this.closest(".skincare-routine, .pdp-tab") || document;
      const activeButton = this.querySelector("button.active");
      if (activeButton) activeButton.classList.remove("active");
      button.classList.add("active");

      const tabId = button.dataset.tabId;
      const activeBlock = scope.querySelector(
        "skincare-routine-block[data-active='true']"
      );
      if (activeBlock) activeBlock.setAttribute("data-active", false);
      const nextBlock = scope.querySelector(
        `skincare-routine-block[data-tab-id='${tabId}']`
      );
      if (nextBlock) nextBlock.setAttribute("data-active", true);
    });
  }
}

customElements.define("skincare-routine-tabs", SkincareRoutineTabs);
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".pdp-tab").forEach((tab) => {
    const ctaElements = tab.querySelectorAll(".skincare-routine-cta");
    if (!ctaElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          ctaElements.forEach((ctaElement) => {
            ctaElement.classList.toggle("visible", entry.isIntersecting);
          });
        });
      },
      {
        rootMargin: "-200px 0px 400px 0px",
      }
    );

    observer.observe(tab);
  });
});
